import React from 'react';
import styles from './FullBookDisplay.module.css';

import { database } from '../firebase/firebase.app';
import axios from 'axios';
import firebase from '../firebase/firebase.app';
import bookImg from '../../resources/book2.jpg';
import Spinner from '../UI/Spinner/Spinner';
class FullBookDisplay extends React.Component {
    

    state = {
        mailSent: false,
        loading: true
     }

    componentDidMount() {
        // database.ref(`books/${this.props.match.params.id}`).once("value", snapshot => {
        //     if(snapshot.val()) {
        //         let book = snapshot.val();
        //         console.log(book);
        //         this.setState({
        //             book: book
        //         })
        //     } else {
        //         alert("Could not fetch!");
        //     }
        // })

        axios.get(`https://exbook-wd.herokuapp.com/books/${this.props.match.params.id}`).then(response => {
            console.log(response);
            let book = response.data;
           
            this.setState({
              book: book,
              loading: false
            }, () => {
               console.log("State set!!")
               console.log(this.state.books);
            })
        }).catch(error => {
            console.log(error);
        })
    }

    sendEmail = () => {
        // console.log("Lolol")
        database.ref(`users/${this.state.book.user_fire_id}`).once("value", snapshot => {
            let sellerPhone = 0, user = {}, sellerName = "";
            let currentUser = firebase.auth().currentUser;
            let sellerEmail = "";
            if(snapshot.val()) {
                user = snapshot.val();
                sellerName = user.displayName;
                sellerPhone = user.phoneNumber;
                sellerEmail = user.email;
            }
            // console.log(sellerEmil);
            console.log(sellerPhone);
            console.log(sellerName);
            // let message = "Below are the details of the seller, Please contact to eachother for transaction";
            let urlOne = `https://us-central1-exbook-ac4e3.cloudfunctions.net/sendMail?email=${currentUser.email}&name=${sellerName}&phone=${sellerPhone}&myType=buy&contactEmail=${sellerEmail}`;
            //let urlOne = "htt300ps://us-central1-exbook-ac4e3.cloudfunctions.net/sendMail?email=krunallia18@gmail.com" 
            axios.get(urlOne, {
                params: {
                    message: "Below are the details of the seller, Please contact to eachother for transaction"
                }
            })
            .then(function (response) {
                 console.log(response);

            })
            .catch(function (error) {
                console.log(error);
            });
            
            // let urlOne = `https://us-central1-exbook-ac4e3.cloudfunctions.net/sendMail?email=${currentUser.email}&name=${this.state.book.sellerName}&phone=${this.state.book.sellerPhNo}&myType=buy&contactEmail=${this.state.book.sellerEmail}`;
            let urlTwo = "https://us-central1-exbook-ac4e3.cloudfunctions.net/sendMail" 
            axios.get(urlTwo, {
                params: {
                  email: sellerEmail,
                  name: currentUser.displayName,
                  phone: currentUser.phoneNumber,
                  contactEmail: currentUser.email,
                  message: "Hey! A user is interested in buying your book on ExBook!! Below are the contact details!"
            }
            })
            .then(function (response) {
                 console.log(response);
            })
            .catch(function (error) {
                console.log(error);
            });

            this.setState({
                mailSent: true
            })
        })
    }

    render() {
    
        if (this.state.loading) return <Spinner/>;
        return (
            <div className={styles.main}>
                <div className={styles.leftDiv}>
                    <img src={this.state.book.image} alt="book cover" className={styles.img}/>
                    <h4 
                    className={styles.category}>Tags:</h4>
                    <p>{this.state.book.category.join(', ')}</p>
                </div>
                <div className={styles.rightDiv}>
                    <h1>{this.state.book ? this.state.book.name: null}</h1>
                    <p><em>by</em></p>
                    <h2>{this.state.book ? this.state.book.author.join(', ') : null }</h2>
                    <div className={styles.description}>
                        <h3>Description</h3>
                        <p>
                            { this.state.book ? this.state.book.description : null}
                        </p>
                    </div>
                    
                </div>

                <div className={styles.lastDiv}>
                    <h3>Get this Book!</h3>
                    <p>Condition: <span>{this.state.book ? `${this.state.book.condition} / 10 `: null}</span></p>
                    <p>MRP: <span>{this.state.book ? this.state.book.original_price : null}</span></p>
                    <p>Seller Price: <span>{this.state.book ? this.state.book.discounted_price : null}</span></p>
                   {this.state.mailSent ? "We sent you a mail regarding seller details please check " : <button className={styles.button} onClick={this.sendEmail}>CONTACT SELLER</button> }
                </div>
            </div>
        )
    } 
}

export default FullBookDisplay;